import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=5d1d1c9a&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=5d1d1c9a&prod&lang=scss&scoped=true"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=5d1d1c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d1c9a",
  null
  
)

export default component.exports